import { render, staticRenderFns } from "./IntelligentIdentificationInfoDialog.vue?vue&type=template&id=b6724ff8&"
import script from "./IntelligentIdentificationInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./IntelligentIdentificationInfoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./IntelligentIdentificationInfoDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports